'use client';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { headingStyle } from '../../mixins/headingStyle.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { textColorProp } from '../../mixins/textColorProp.js';

const StyledHeading = styled.h1.withConfig({
  componentId: "sc-1jhyaju-0"
})(["", ";", " ", ";", " ", ";"], defaultStyles.fontSmoothing, ({
  color
}) => textColorProp(color), ({
  heading
}) => headingStyle(heading), ({
  spaceAfter
}) => spaceProp(spaceAfter), ({
  isTruncated
}) => isTruncated && defaultStyles.ellipsis);
const Heading = /*#__PURE__*/withTitan(({
  renderAs,
  heading,
  id,
  children,
  className,
  spaceAfter,
  isTruncated,
  color = 'grey90',
  testId = 'heading'
}, ref) => {
  const renderAsDefault = heading === 'subtitle' ? 'h3' : heading;
  return jsx(StyledHeading, {
    ref: ref,
    as: renderAs || renderAsDefault,
    className: className,
    color: color,
    "data-test-id": testId,
    heading: heading,
    id: id,
    isTruncated: isTruncated,
    spaceAfter: spaceAfter,
    children: children
  });
}, {
  name: 'Heading'
});

export { Heading };
//# sourceMappingURL=Heading.js.map
